import httpService from "../../components/service";

export const shades = {
    namespaced: true,
    state: {
        shades: []
    },
    getters: {
        getShades: state => {
            return state.shades;
        }
    },
    mutations: {
        SET_SHADES(state, shades) {
            state.shades = shades;
        }
    },
    actions: {
        async getShadesAction(context, objSearch) {
            const res = await httpService.get("/components_shade?" + objSearch);
            context.commit("SET_SHADES", res);
            return res;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/shades/shades.js